import { HANDLE_UNCAUGHT_EXCEPTION } from 'actions/exceptions/handleUncaughtException';
import { HANDLE_CONNECTION_EXCEPTION } from 'actions/exceptions/handleConnectionException';
import { HANDLE_SERVER_EXCEPTION } from 'actions/exceptions/handleServerException';

// eslint-disable-next-line default-param-last
function exceptions(state = {}, action) {
  switch (action.type) {
    case HANDLE_UNCAUGHT_EXCEPTION:
      return {
        ...state,
        code: action.code,
        message: action.message
      };
    case HANDLE_CONNECTION_EXCEPTION:
      return {
        ...state,
        code: action.code,
        message: action.message
      };
    case HANDLE_SERVER_EXCEPTION:
      return {
        ...state,
        code: action.code,
        message: action.message,
        id: action.id
      };
    default:
      return state;
  }
}

export default exceptions;
